import { render, staticRenderFns } from "./ContractAcceptView.vue?vue&type=template&id=13f2f795&scoped=true&"
import script from "./ContractAcceptView.vue?vue&type=script&lang=js&"
export * from "./ContractAcceptView.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/all-admin.css?vue&type=style&index=0&id=13f2f795&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f2f795",
  null
  
)

export default component.exports